import { memo } from "react";
import { FleetDocumentUpload } from "services/api/fleet/vehicles/documents/types";
import DamagePinOverlay, {
  DamagePin,
} from "../../VehicleDamageSearchPage/components/DamagePinOverlay/DamagePinOverlay";

interface DamagePhotoPanelProps {
  photos: FleetDocumentUpload[];
  selectedPhotoId: string | null;
  pins: DamagePin[];
  activePin: string | null;
  onImageClick: (x: number, y: number) => void;
  onPinClick: (id: string) => void;
  onUploadClick: () => void;
}

const DamagePhotoPanel: React.FC<DamagePhotoPanelProps> = ({
  photos,
  selectedPhotoId,
  pins,
  activePin,
  onImageClick,
  onPinClick,
  onUploadClick,
}) => {
  const selectedPhoto = photos.find((p) => p.id === selectedPhotoId);

  return (
    <div className="flex-1 flex flex-col min-h-0">
      {selectedPhoto ? (
        <div className="flex-1 min-h-0 overflow-auto rounded-sm">
          <DamagePinOverlay
            imageUrl={selectedPhoto.url}
            pins={pins}
            onImageClick={onImageClick}
            onPinClick={onPinClick}
            interactive
            activePin={activePin}
          />
        </div>
      ) : (
        <div
          onClick={onUploadClick}
          className="flex-1 flex flex-col items-center justify-center border-2 border-dashed border-blue-300 bg-slate-50 rounded-sm p-8 cursor-pointer hover:bg-blue-50 transition-colors"
        >
          <img
            src="/media/images/upload.svg"
            alt=""
            className="w-40 h-40 mb-4 opacity-60"
          />
          <p className="text-sm font-medium text-slate-700 mb-1">
            Dodajte fotografije za postavljanje pinova
          </p>
          <p className="text-xs text-slate-400">
            Kliknite ovdje za upload fotografija
          </p>
        </div>
      )}
    </div>
  );
};

export default memo(DamagePhotoPanel);
